import script from "./SuperPromo.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperPromo.vue?vue&type=script&setup=true&lang=js"

import "./SuperPromo.vue?vue&type=style&index=0&id=779c89b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779c89b2"]])

export default __exports__